interface Props {
  // Page title and filter bar, inside the scroll box so they scroll away
  // upward while the header rows stick. Pinned left at the box's visible
  // width so sideways scrolling leaves them in place.
  top?: React.ReactNode;
  children: React.ReactNode;
}

// The Inventory Overview scroll box: scrolls both ways, and the grid
// header rows inside it stick to its top.
export default function MatrixScrollBox({ top, children }: Props) {
  return (
    <div
      style={{
        background: "var(--background)",
        overflow: "auto",
        flex: 1,
        minHeight: 0,
      }}
    >
      {top && <div style={{ position: "sticky", left: 0 }}>{top}</div>}
      {children}
    </div>
  );
}
